import dynamic from 'next/dynamic';

import { ConditionalWrapper } from '@/hoc';
import { Container, Text } from '@/atoms';
import { CardAdvantage, WithPaperBorder } from '@/molecules';
import { Positions } from '@/molecules/with-paper-border/types';

import { containerTransformer } from '@/lib/graphql/transformers';

const ArrowDown = dynamic(
  () => import('@/icons/ArrowDown').then((m) => m.ArrowDown),
  {
    ssr: false,
  },
);

const VentajasFlexible = ({ bloque, id }: any) => (
  <>
    {bloque.showSeparador && (
      <Container
        id={`${id}-separator`}
        align="items-center"
        justify="justify-center"
        padding="p-0"
        className="hidden md:flex"
        backgroundTop={{ backgroundColor: 'white' }}
        backgroundBottom={{ backgroundColor: 'white' }}
      >
        <ArrowDown className="absolute -top-8 z-20 mx-auto mt-3" />
      </Container>
    )}

    <WithPaperBorder
      id={id}
      top={
        bloque.papelRasgado.zona === Positions.top ||
        bloque.papelRasgado.zona === Positions.topBottom
      }
      bottom={
        bloque.papelRasgado.zona === Positions.bottom ||
        bloque.papelRasgado.zona === Positions.topBottom
      }
      border={bloque.papelRasgado.border}
      borderHeight={bloque.papelRasgado.borderHeight}
      borderColor={bloque.papelRasgado.borderColor}
    >
      {(bloque.pretitulo || bloque.titulo) && (
        <Container id={`${id}-headings`} wrapper>
          <div className="my-4 flex w-full flex-col items-center md:mb-4 md:mt-[75px]">
            {bloque.pretitulo && (
              <p className="u-actions--link mb-4 block text-secondary-500">
                {bloque.pretitulo}
              </p>
            )}

            {bloque.titulo && (
              <>
                {bloque.titleSize === 'large' && (
                  <Text
                    as={bloque.headingType}
                    className="text-center font-primary text-5xl leading-[62px] md:text-8xl md:leading-none"
                  >
                    {bloque.titulo}
                  </Text>
                )}
                {bloque.titleSize === 'normal' && (
                  <Text
                    as={bloque.headingType}
                    className="u-headline u-headline--h1"
                  >
                    {bloque.titulo}
                  </Text>
                )}
              </>
            )}
          </div>
        </Container>
      )}

      {bloque.tarjetasVentajas.map((item: any, index: number) => {
        const advantages = item.tarjetaVentaja;
        const theNextHasPaperBorder =
          index < bloque.tarjetasVentajas.length - 1
            ? bloque.tarjetasVentajas[index + 1].tarjetaVentaja.papelRasgado
                .zona !== 'none'
            : false;
        const hasPaperBorder = advantages.papelRasgado.zona !== 'none';
        const isTheLast = index === bloque.tarjetasVentajas.length - 1;
        const hasBorder =
          !theNextHasPaperBorder && !hasPaperBorder && !isTheLast;

        return (
          <ConditionalWrapper
            key={index}
            condition={hasPaperBorder}
            wrapper={(children) => (
              <WithPaperBorder
                id={`${id}-advantages-${index}`}
                top={
                  advantages.papelRasgado.zona === Positions.top ||
                  advantages.papelRasgado.zona === Positions.topBottom
                }
                bottom={
                  advantages.papelRasgado.zona === Positions.bottom ||
                  advantages.papelRasgado.zona === Positions.topBottom
                }
                border={advantages.papelRasgado.border}
                borderHeight={advantages.papelRasgado.borderHeight}
                borderColor={advantages.papelRasgado.borderColor}
              >
                {children}
              </WithPaperBorder>
            )}
          >
            <Container
              {...(!hasPaperBorder && { id: `${id}-advantages-${index}` })}
              {...containerTransformer({
                colorDeFondo: advantages.backgroundColor,
                imagenBase: advantages.imagenBase,
                srcset: advantages.srcset,
              })}
              wrapper
              padding="px-6"
            >
              <CardAdvantage
                image={advantages.image}
                filas={advantages.filas}
                imagePositionDesktop={advantages.imagePositionDesktop}
                imagePositionMobile={advantages.imagePositionMobile}
                imageMaxWidth={advantages.imageMaxWidth}
                showImageMobile={advantages.showImageMobile}
                textOrientation={advantages.textOrientation}
                isDark={advantages.theme === 'dark'}
                className={
                  hasBorder ? 'border-b border-dashed border-primary-900' : ''
                }
              />
            </Container>
          </ConditionalWrapper>
        );
      })}
    </WithPaperBorder>
  </>
);

export default VentajasFlexible;
VentajasFlexible.displayName = 'FlexibleVentajas';
